<template>
  <div class="home">
    <div class="home-container" v-if="m === null || !isMobile">
      <NotFound v-if="fetched && page404" :data="data"></NotFound>
      <div class="home-nav">
        <AppHeader
          v-if="restored && !page404"
          :isLogin="isLogin"
          :isMyHome="isMyHome"
          :isEditMode="isEditMode"
          @clickSignup="m = 'signup'"
          @clickSignupMp="clickSignupMp"
          @clickResetPassword="m = 'reset-password'"

          @clickSignin="clickSigninFromNav"
          @clickSigninMp="clickSigninMp"
          @clickSignout="logout"

          @clickShare="m = 'share'"
          @clickEdit="clickEdit"
          @clickInbox="clickInbox"
          @clickAvatar="clickAvatar"
        ></AppHeader>
      </div>
      <div v-if="!fetched || !page404" class="home-header"></div>
      <User
        v-if="fetched && data && !page404"
        :data="data"
        :config="config"
        :isLogin="isLogin"
        :isShowSend="isShowSend"
        :isEditMode="isEditMode"
        :isMyHome="isMyHome"
        @clickSignin="clickSigninFromSendbpButton"
        @update:user="updateUser"
        @update:me="updateMe"
        @update:module="updateModule"
        @update:m="updateM"
        @clickShareMp="clickShareMp"
        @wxmp="wxmp"
      ></User>
      <AppFooter v-if="isShowFooter && fetched && !page404"></AppFooter>
      <div v-if="wxmpDebug">
        <input placeholder="wxmpInput.method" v-model="wxmpInput.method" />
        <input placeholder="wxmpInput.signupUrl" v-model="wxmpInput.signupUrl" />
        <input placeholder="wxmpInput.loginUrl" v-model="wxmpInput.loginUrl" />
      </div>
      <div :style="footerBlankStyle"></div>
    </div>

    <SignupModal
      v-if="m === 'signup'"
      :error="error"
      @close="closeModal"
      @commit="commitSignup"
      @signin="m = 'signin'"
      @update:error="updateError"
    ></SignupModal>
    <ResetPasswordModal
      v-if="m === 'reset-password'"
      :error="error"
      :isNutsbp="isNutsbp"
      @close="closeModal"
      @commit="commitResetPassword"
      @signin="m = 'signin'"
      @corner="m = 'weixin-qrcode'"
      @update:error="updateError"
    ></ResetPasswordModal>
    <SigninModal
      v-if="m === 'signin'"
      :error="error"
      :isNutsbp="isNutsbp"
      @close="closeModal"
      @commit="commitSignin"
      @reset="m = 'reset-password'"
      @signup="m = 'signup'"
      @corner="m = 'weixin-qrcode'"
      @update:error="updateError"
    ></SigninModal>
    <WeixinQrcodeModal
      v-if="m === 'weixin-qrcode'"
      :error="error"
      @close="closeModal"
      @commit="commitSignin"
      @reset="m = 'reset-password'"
      @signup="m = 'signup'"
      @corner="m = 'signin'"
      @update:error="updateError"
    ></WeixinQrcodeModal>
    <QrcodeModal v-if="m === 'qrcode'" @close="closeModal"></QrcodeModal>
    <ConfirmModal
      v-if="m === 'home'"
      :lang="{
        close: '留在原地',
        commit: '前往主页'
      }"
      @close="closeModal"
      @commit="goHome"
    >当前页面不是你的个人主页，请选择是否前往您的个人主页</ConfirmModal>

    <BrowserShareCover v-if="m === 'share' && isMobile && !isWeixinBrowser && !isChrome" @click="m=null"></BrowserShareCover>
    <WeixinShareCover v-if="m === 'share' && isMobile && (isWeixinBrowser || isChrome)" @click="m=null"></WeixinShareCover>
    <wx
      v-if="fetched && isWeixinBrowser"
      :debug="debug"
      :title="shareTitle"
      :desc="shareDesc"
      :imgUrl="shareImgUrl"
      @updateWx="updateWx"
    ></wx>
  </div>
</template>

<script>
import _ from 'lodash'
import md5 from 'blueimp-md5'
import wx from '@/wx.vue'
import env from '@/env.js'
import util from '@/util.js'
import Mem from '@/Mem.js'
import Store from '@/Store.js'
import defaultMdList from './defaultMdList.js'

import {
  conf,
  nutsbpV2,
  dcV1,
  dcV2Graphql,
  ranch
} from '@/api'

import {
  SignupModal,
  WeixinQrcodeModal,
  ResetPasswordModal,
  SigninModal,
  QrcodeModal,
  ConfirmModal,
  BrowserShareCover,
  WeixinShareCover
} from '@/components'
import {
  User,
  Header as AppHeader,
  Footer as AppFooter,
  NotFound
} from '@/containers'

export default {
  components: {
    wx,
    SignupModal,
    WeixinQrcodeModal,
    ResetPasswordModal,
    SigninModal,
    QrcodeModal,
    ConfirmModal,
    BrowserShareCover,
    WeixinShareCover,
    User,
    AppHeader,
    AppFooter,
    NotFound
  },
  data () {
    let stageSrc = ['种子', '天使轮', 'Pre-A', 'A轮', 'B轮', 'C轮', 'D轮', 'Pre-IPO', 'IPO']
    return {
      m: null,
      isLocked: true,
      isLogin: false,
      isMyHome: false,
      isEditMode: false,
      restored: false,
      pullerTriggered: false,
      fetched: false,
      error: null, // 共用 response error payload
      data: null,
      defaultMdList,
      config: {
        stageSrc,
        stage: stageSrc.map(row => {
          return {
            label: row,
            value: row
          }
        }),
        industry: []
      },
      needInit: false,
      wxmpInput: {
        // DO NOT use redirectTo or reLaunch, it's not work in real device
        method: this.$route.query.wxmpMethod || 'navigateTo',
        signupUrl: this.$route.query.wxmpSignup ? decodeURIComponent(this.$route.query.wxmpSignup) : '/pages/index?type=signup',
        loginUrl: this.$route.query.wxmpLogin ? decodeURIComponent(this.$route.query.wxmpLogin) : '/pages/index?type=login'
      },
      isNutsbp: false
    }
  },
  computed: {
    debug () {
      return env.debug
    },
    wxmpDebug () {
      return this.$route.query.hasOwnProperty('wxmpDebug')
    },
    isMobile () {
      return env.isMobile
    },
    isChrome () {
      return env.ua.browser.name === 'Chrome'
    },
    isWeixinBrowser () {
      return env.ua.browser.name === 'WeChat'
    },
    pageAccount () {
      return util.pathToUserId(location.pathname)
    },
    pageDomain () {
      return `${this.pageAccount}.dartcome.com`
    },
    page404 () {
      return _.get(this.data, 'pr_state') !== 1
    },
    isShowSend () {
      return this.$route.query.send !== 'hide'
    },
    isShowFooter () {
      return this.$route.query.footer !== 'hide'
    },
    footerBlankStyle () {
      if (!this.$route.query.fheight) {
        return ''
      }
      return `width:100%;height:${this.$route.query.fheight}`
    },
    shareTitle () {
      let name = _.get(this.data, 'card.name', this.pageAccount)
      return `向${name}投递BP`
    },
    shareDesc () {
      let rList = []
      let title = _.get(this.data, 'card.title')
      if (title) {
        rList.push(`${title}`)
      }
      let labels = []
      labels = _.get(this.data, 'user_module[0].value[0].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`投资阶段: ${labels.join('/')}`)
      }
      labels = _.get(this.data, 'user_module[0].value[1].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`关注领域: ${labels.join('/')}`)
      }
      if (rList.length <= 0) {
        return this.pageDomain
      }
      return rList.join(', ')
    },
    shareImgUrl () {
      let url = _.get(this.data, 'card.head_image_url')
      if (url) {
        return url
      }
      return 'https://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_logo.png'
    }
  },
  methods: {
    updateM (m) { this.m = m },
    updateWx (wx) { this.wx = wx },
    closeModal () {
      this.m = null
      this.error = null
    },
    updateError (e) {
      this.error = util.errorToMessage(e)
      if (e) {
        console.error('updateError e', e, this.error)
      }
    },
    async afterLogin (data) {
      Mem.set('me.u', data)
      const uuid = _.get(data, 'uuid')
      if (uuid === _.get(this.data, 'uuid')) {
        this.isMyHome = true
      }
      this.isLogin = true

      this.saveTokenByAuthData(data)
      if (this.isMyHome) {
        // this.isEditMode = true
        if (this.needInit) {
          await this.createInitialModule()
        }
      }
    },
    async afterRestoreNutsbp (data) {
      Mem.set('nutsbp', data)
      this.saveTokenByAuthData(data)
    },
    async saveTokenByAuthData (data) {
      if (data && data['.session_id']) {
        let sessionId = data['.session_id']
        Store.set('sid', sessionId)
      }
      if (data && data['.u']) {
        let u = data['.u']
        Mem.set('u', u)
      }
    },
    async restoreDartcome () {
      let data = await this.$store.dispatch('api/dartcome/fixedMe')
      return data
    },
    async restoreNutsbp () {
      let res = await nutsbpV2.get('/me', {
        headers: {
          'tephra-session-id': Store.get('sid')
        }
      })
      return _.get(res, 'data.data')
    },
    async restore () {
      try {
        let data = await Promise.all([
          this.restoreDartcome(),
          this.restoreNutsbp()
        ])
        this.afterLogin(data[0])
        this.afterRestoreNutsbp(data[1])
      } catch (e) {
        this.updateError(e)
      }
      this.restored = true
    },
    logout () {
      Store.clear()
      window.location.reload()
    },
    async commitResetPassword (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }
      try {
        let options = {
          uid: input.phone,
          password: input.password,
          smsCode: input.code
        }
        await ranch.post('/user/reset-password', options)
        // let options = {
        //   phone: input.phone,
        //   verify_code: input.code,
        //   password: input.password
        // }
        // await dcV1.patch('/password', options)
        this.m = 'signin'
      } catch (e) {
        this.updateError(e)
      }
    },

    async commitSignup (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }

      let options = {
        phone: input.username,
        verify_code: input.code,
        password: input.password
      }

      try {
        let res = await dcV1.post('/u/register/', options)
        let data = _.get(res, 'data.data')
        this.afterLogin(data)

        let data2 = await this.restoreNutsbp()
        this.afterRestoreNutsbp(data2)

        this.closeModal()
      } catch (e) {
        this.updateError(e)
      }
    },
    async commitSignin (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }
      try {
        let sid = `dartcome:${md5(input.username, input.password)}`
        let res = await ranch.post('/user/sign-in', {
          uid: input.username,
          password: input.password,
          type: 1
        }, {
          headers: {
            'tephra-session-id': sid
          }
        })
        let code = _.get(res, 'data.code')
        if (code !== 0) {
          throw new Error(_.get(res, 'data.msg', '登入失败'))
        }
        Store.set('sid', sid)
        return window.location.reload()
        // let res = await dcV1.post('/login', {
        //   phone: input.username,
        //   password: input.password
        // })
        // let data = _.get(res, 'data.data')
        // this.afterLogin(data)

        // let data2 = await this.restoreNutsbp()
        // this.afterRestoreNutsbp(data2)

        // this.closeModal()
      } catch (e) {
        this.updateError(e)
      }
    },

    goHome () {
      window.location.href = `${window.location.origin}/u/${Mem.get('me.u.account')}`
    },
    clickEdit () {
      if (!this.isLogin || !this.isMyHome) {
        // this.m = 'home'
        this.goHome()
        return
      }
      this.isEditMode = !this.isEditMode
    },
    clickInbox () {
      window.open(`https://${env.baseDomain}`, '__blank')
    },
    clickAvatar () { console.log('clickAvatar') },
    clickShareMp () {
      if (this.wx && this.wx.miniProgram) {
        wx.miniProgram.postMessage({ api: 'showShareMenu' })
      }
    },
    clickSignupMp () {
      let method = this.wxmpInput.method
      let url = this.wxmpInput.signupUrl
      this.wxmp(method, { url })
    },
    clickSigninFromSendbpButton () {
      this.isNutsbp = true
      this.clickSignin()
    },
    clickSigninFromNav () {
      this.isNutsbp = false
      this.clickSignin()
    },
    clickSignin () {
      if (this.restored) {
        this.m = 'weixin-qrcode'
      }
    },
    clickSigninMp () {
      let method = this.wxmpInput.method
      let url = this.wxmpInput.loginUrl
      this.wxmp(method, { url })
    },
    wxmp (method, opts) {
      // wx.miniProgram.getEnv(function (res) {
      //   console.log(res.miniprogram) // true
      // })
      console.log(`try wxmp: ${method}`, opts)
      if (this.wx && this.wx.miniProgram) {
        this.wx.miniProgram[method](opts)
      }
    },

    async fetch () {
      try {
        let data = null
        if (window.__data) {
          data = _.get(window.__data, 'user[0]')
        } else {
          data = await this.fetchPageData()
        }
        if (!data) {
          throw new Error(`data not found (${this.pageAccount})`)
        }

        if (this.config.industry.length <= 0) {
          this.config.industry = await this.fetchIndustryConfig()
        }

        if (
          !data.user_module ||
          !Array.isArray(data.user_module) ||
          data.user_module.length <= 0
        ) {
          data.user_module = _.cloneDeep(this.defaultMdList)
          this.needInit = true
        } else {
          data.user_module = this.parseModule(data.user_module)
        }

        // replace by deliverFinish
        // let qaCount = await this.fetchQaSends(_.get(data, 'uuid'))
        // data.investor.qaCount = qaCount

        this.data = data
      } catch (e) {
        console.error('fetch e', e)
      } finally {
        this.fetched = true
      }
    },
    async fetchQaSends (uuid) {
      let res = await ranch.post('/deliver/qa/sends', {
        user: uuid
      })
      return _.get(res, 'data.data')
    },
    async fetchPageData () {
      if (!this.pageAccount) {
        return null
      }
      let res = await dcV2Graphql.post('/', {
        // !!! update query must update src/router/html/index.js __data too
        query: `query ($account: [String]) {
          user (account: $account) {
            uuid, account,
            province, city,
            pr_state, pv,
            card { _id, name, phone, email, title, profile, head_image_url },
            homepage { auto_open, url },
            investor {
              deliverPrice,
              deliverCount,
              deliverIncome,
              deliverAnswerRate,
              deliverFinish,
              state
            },
            user_module { id, name, type, data }
          }
        }`,
        variables: {
          account: [this.pageAccount]
        }
      })
      let data = _.get(res, 'data.data.user[0]')
      if (!data) {
        throw new Error('fetchPageData failed')
      }
      return data
    },
    async fetchIndustryConfig () {
      try {
        let res = await conf.get('/db/industry.json')
        /**
         * from [{industry_id: 11, name: "智能硬件   ", show: 1, rank: 11}]
         * to [{label: "智能硬件", value: 11}]
         */
        return _.get(res, 'data', [])
          .filter(row => {
            if (row.show === 1) {
              return true
            }
            return false
          })
          .map(row => {
            return {
              label: _.trim(row.name),
              value: row.industry_id
            }
          })
      } catch (e) {
        return []
      }
    },

    parseModule (list) {
      let md0 = _.find(list, { type: 'preference' })
      let md1 = _.find(list, { type: 'case' })
      return [
        {
          id: md0.id,
          type: 'md-list',
          name: '投资偏好',
          value: [
            {
              type: 'tag',
              name: '投资阶段',
              ref: 'stage',
              value: _.sortBy(_.get(md0, 'data.stage', []), item => {
                return this.config.stageSrc.indexOf(item)
              })
            },
            {
              type: 'tag',
              name: '投资领域',
              ref: 'industry',
              value: _.sortBy(_.get(md0, 'data.field', []), item => {
                return _.findIndex(this.config.industry, {value: item})
              })
            },
            {
              type: 'range',
              name: '单个项目投资金额',
              unit: 10000,
              value: _.get(md0, 'data.amount', [])
            }
          ]
        },
        {
          id: md1.id,
          type: 'md-case',
          name: '投资案例',
          value: _.get(md1, 'data', []).map(row => {
            return {
              type: 'media',
              name: _.get(row, 'name'),
              value: _.get(row, 'desc'),
              label: _.get(row, 'industry'),
              logo: _.get(row, 'logo'),
              img: _.get(row, 'logo.url')
            }
          })
        }
      ]
    },

    async createInitialModule () {
      let query = `mutation ($name: String, $type: String, $data: JSON, $metadata: JSON) {
        createUserModule(name: $name, type: $type, data: $data, metadata: $metadata) { id }
      }`
      let res = await Promise.all([
        await dcV2Graphql.post('', {
          query,
          variables: {
            type: 'preference',
            data: {
              amount: [0, 0], // [min, max]
              field: [], // [id, ...]
              stage: [] // ["A", "B", ...]
            }
          }
        }, {
          headers: {
            'tephra-session-id': Store.get('sid')
          }
        }),
        await dcV2Graphql.post('', {
          query,
          variables: {
            type: 'case',
            data: [
              {
                desc: '', // string(2048)
                industry: '', // string(32)
                name: '' // string(32)
              }
            ]
          }
        }, {
          headers: {
            'tephra-session-id': Store.get('sid')
          }
        })
      ])
      console.log('createInitialModule res', res)
    },

    startGlobalPulling (interval = 15000) {
      let handleId = setTimeout(async () => {
        try {
          let data = await this.pullWxmpMayUpdatePageData()
          this.updateUser(data)
        } catch (e) {
          console.error('startGlobalPulling e', e)
        }
        clearTimeout(handleId)
        this.startGlobalPulling(interval)
      }, interval)
    },
    async pullWxmpMayUpdatePageData () {
      if (!this.pageAccount) {
        return null
      }
      let res = await dcV2Graphql.post('/', {
        query: `query ($account: [String]) {
          user (account: $account) {
            card { name, email, title, head_image_url },
          }
        }`,
        variables: {
          account: [this.pageAccount]
        }
      }, {
        loading: false
      })
      let data = _.get(res, 'data.data.user[0]')
      if (!data) {
        throw new Error('pullPageData failed')
      }
      return data
    },

    updateUser (partial) {
      _.merge(this.data, partial)
      if (document) {
        // this format must same as server render
        // see src/Util.js userToTitle
        document.title = _.get(this.data, 'card.name', '') + ' ' + _.get(this.data, 'card.title', '') + ' | 大咖'
      }
    },
    updateMe (partial) {
      Mem.merge('me.u', partial)
    },
    updateModule (i, partial) {
      // this.data.user_module[i].value = _.merge(this.data.user_module[i].value, partial)
      this.data.user_module[i].value = partial
    }
  },
  watch: {
    isMyHome (newValue, oldValue) {
      if (!newValue) {
        this.m = 'home'
      }
    }
  },
  // created () {
  //   this.$validator.attach({name: 'username', rules: 'required|regex:^.{11}$', alias: '手机号'})
  //   this.$validator.attach({name: 'password', rules: 'required|min:6|max:16', alias: '密码'})
  //   this.$validator.attach({name: 'code', rules: 'required|min:6|max:6', alias: '验证码'})
  // },
  async mounted () {
    let newQuery = { ...this.$route.query }
    let sid = newQuery.sid
    if (sid) {
      Store.set('sid', sid)
      delete newQuery.sid
    }
    if (sid) {
      this.$router.push({
        name: 'home',
        query: newQuery
      })
    }
    await this.fetch()
    await this.restore()

    if (!this.pullerTriggered && this.$route.query.hasOwnProperty('pull')) {
      let interval = 15000
      if (this.$route.query.hasOwnProperty('pull-ms')) {
        interval = parseInt(this.$route.query['pull-ms'])
      }
      if (!Number.isFinite(interval)) {
        console.error('pull-ms parse error')
        return
      }
      this.startGlobalPulling(interval)
      this.pullerTriggered = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import "index.css";
.home {
  & .home-nav {
    position: relative;
    max-width: 1024px;
    margin: auto;
  }
  & .home-header {
    background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_page_top_bar.png');
    background-size: cover;
    background-position: center;
    @media (--mediaPc) {
      height: 230px;
    }
    @media (--mediaMobile) {
      height: calc(230px / var(--scaleMobile));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/HomePage.vue